module.exports = __webpack_public_path__ + "static/media/filter-instructor.5dd792e7.svg";